import { takeLatest, call, put } from 'redux-saga/effects'

// Helper for api errors
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
let clientApi = axiosApi()


// Our login constants
import {
  ACTIVEACC_REQUESTING,
  ACTIVEACC_SUCCESS,
  ACTIVEACC_ERROR,
  ACTIVEACC_URL,
} from './constants'

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function activeAccApi (formData) {
  const request = clientApi.post(ACTIVEACC_URL, 
    formData
  );
  return handleRequest(request);
}

function* activeAccFlow (action) {
  try {
    const { formData } = action
    var result = yield call(activeAccApi, formData)
    if (result.code != 200) {
      yield put({ type: ACTIVEACC_ERROR, error: result.message })
    } else {
      yield put({ type: ACTIVEACC_SUCCESS, message: result.message })
    }
    
  } catch (error) {
    // error? send it to redux
    yield put({ type: ACTIVEACC_ERROR, error })
  }
}

// Our watcher (saga).  It will watch for many things.
function* activeAccWatcher () {
  yield takeLatest(ACTIVEACC_REQUESTING, activeAccFlow)
}

export default activeAccWatcher



// WEBPACK FOOTER //
// ./src/views/Pages/ActiveAcc/sagas.js